"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HotKeyContext;

var _react = _interopRequireWildcard(require("react"));

var _reactHotkeys = require("react-hotkeys");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable no-alert */
function HotKeyContext(_ref) {
  var children = _ref.children;
  var keyMap = (0, _react.useMemo)(function () {
    return {
      MOVE_FORWARD: "w",
      MOVE_BACKWPARD: "s",
      MOVE_LEFT_TURN: "a",
      MOVE_RIGHT_TURN: "d",
      SIT_DOWN_STAND_UP: "x",
      WALK_RUN: "r",
      OFFENSIVE_PEACE: "q",
      SPRINT: "f",
      JUMP: "space",
      AUTO_RUN: "tab",
      EQUIPMENT_WINDOW: "i",
      STATUS_WINDOW: "c",
      SKILL_WINDOW: "k",
      MINI_MAP: "m",
      HIDE_INTERFACE: "~",
      CLOSE_WINDOW: "esc",
      SCREENSHOT: "print",
      SWITCH_PERSPECTIVE: "F12",
      PET_SKILL_1: "F1",
      PET_SKILL_2: "F2",
      PET_SKILL_3: "F3",
      PET_SKILL_4: "F4",
      PET_SKILL_5: "F5",
      TARGET_NEAREST_NPC: "F6",
      TARGET_NEAREST_PC: "F7",
      TARGET_NEAREST_NPC_PC: "F8",
      TARGET_YOURSELF: "F9",
      HELP: "F11",
      WHISPER: "t",
      REPLY_TO_WHISPER: "y",
      PARTY: "g",
      EXCHANGE_WEAPON: "e",
      GUILD: "n",
      ZOOM_IN: "up",
      ZOOM_OUT: "down",
      ROTATE_LEFT: "left",
      ROTATE_RIGHT: "right",
      ROTATE_180_DEGREES: "end",
      QUEST_WINDOW: "u",
      AUTO_LOOT: "v",
      TOGGLE_CHAT: {
        action: "keydown",
        sequence: "Enter"
      }
    };
  }, []);
  var handlers = (0, _react.useMemo)(function () {
    return {
      MOVE_FORWARD: function MOVE_FORWARD() {
        return alert("MOVE_FORWARD");
      },
      MOVE_BACKWPARD: function MOVE_BACKWPARD() {
        return alert("MOVE_BACKWPARD");
      },
      MOVE_LEFT_TURN: function MOVE_LEFT_TURN() {
        return alert("MOVE_LEFT_TURN");
      },
      MOVE_RIGHT_TURN: function MOVE_RIGHT_TURN() {
        return alert("MOVE_RIGHT_TURN");
      },
      SIT_DOWN_STAND_UP: function SIT_DOWN_STAND_UP() {
        return alert("SIT_DOWN_STAND_UP");
      },
      WALK_RUN: function WALK_RUN() {
        return alert("WALK_RUN");
      },
      OFFENSIVE_PEACE: function OFFENSIVE_PEACE() {
        return alert("OFFENSIVE_PEACE");
      },
      SPRINT: function SPRINT() {
        return alert("SPRINT");
      },
      JUMP: function JUMP() {
        return alert("JUMP");
      },
      AUTO_RUN: function AUTO_RUN() {
        return alert("AUTO_RUN");
      },
      EQUIPMENT_WINDOW: function EQUIPMENT_WINDOW() {
        return alert("EQUIPMENT_WINDOW");
      },
      STATUS_WINDOW: function STATUS_WINDOW() {
        return alert("STATUS_WINDOW");
      },
      SKILL_WINDOW: function SKILL_WINDOW() {
        return alert("SKILL_WINDOW");
      },
      MINI_MAP: function MINI_MAP() {
        return alert("MINI_MAP");
      },
      HIDE_INTERFACE: function HIDE_INTERFACE() {
        return alert("HIDE_INTERFACE");
      },
      CLOSE_WINDOW: function CLOSE_WINDOW() {
        return alert("CLOSE_WINDOW");
      },
      SCREENSHOT: function SCREENSHOT() {
        return alert("SCREENSHOT");
      },
      SWITCH_PERSPECTIVE: function SWITCH_PERSPECTIVE() {
        return alert("SWITCH_PERSPECTIVE");
      },
      PET_SKILL_1: function PET_SKILL_1() {
        return alert("PET_SKILL_1");
      },
      PET_SKILL_2: function PET_SKILL_2() {
        return alert("PET_SKILL_2");
      },
      PET_SKILL_3: function PET_SKILL_3() {
        return alert("PET_SKILL_3");
      },
      PET_SKILL_4: function PET_SKILL_4() {
        return alert("PET_SKILL_4");
      },
      PET_SKILL_5: function PET_SKILL_5() {
        return alert("PET_SKILL_5");
      },
      TARGET_NEAREST_NPC: function TARGET_NEAREST_NPC() {
        return alert("TARGET_NEAREST_NPC");
      },
      TARGET_NEAREST_PC: function TARGET_NEAREST_PC() {
        return alert("TARGET_NEAREST_PC");
      },
      TARGET_NEAREST_NPC_PC: function TARGET_NEAREST_NPC_PC() {
        return alert("TARGET_NEAREST_NPC_PC");
      },
      TARGET_YOURSELF: function TARGET_YOURSELF() {
        return alert("TARGET_YOURSELF");
      },
      HELP: function HELP() {
        return alert("HELP");
      },
      WHISPER: function WHISPER() {
        return alert("WHISPER");
      },
      REPLY_TO_WHISPER: function REPLY_TO_WHISPER() {
        return alert("REPLY_TO_WHISPER");
      },
      PARTY: function PARTY() {
        return alert("PARTY");
      },
      EXCHANGE_WEAPON: function EXCHANGE_WEAPON() {
        return alert("EXCHANGE_WEAPON");
      },
      GUILD: function GUILD() {
        return alert("GUILD");
      },
      ZOOM_IN: function ZOOM_IN() {
        return alert("ZOOM_IN");
      },
      ZOOM_OUT: function ZOOM_OUT() {
        return alert("ZOOM_OUT");
      },
      ROTATE_LEFT: function ROTATE_LEFT() {
        return alert("ROTATE_LEFT");
      },
      ROTATE_RIGHT: function ROTATE_RIGHT() {
        return alert("ROTATE_RIGHT");
      },
      ROTATE_180_DEGREES: function ROTATE_180_DEGREES() {
        return alert("ROTATE_180_DEGREES");
      },
      QUEST_WINDOW: function QUEST_WINDOW() {
        return alert("QUEST_WINDOW");
      },
      AUTO_LOOT: function AUTO_LOOT() {
        return alert("AUTO_LOOT");
      },
      TOGGLE_CHAT: function TOGGLE_CHAT() {
        return alert("TOGGLE_CHAT");
      }
    };
  }, []);
  return /*#__PURE__*/_react.default.createElement(_reactHotkeys.HotKeys, {
    keyMap: keyMap,
    handlers: handlers
  }, children);
}